module.exports = __webpack_public_path__ + "static/media/3.9337e099.svg";